import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Client } from "@/types/client";

interface ClientViewDialogProps {
  client?: Client;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function ClientViewDialog({ client, open, onOpenChange }: ClientViewDialogProps) {
  if (!client) return null;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>عرض بيانات العميل</DialogTitle>
        </DialogHeader>
        
        <div className="grid gap-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="space-y-2">
              <Label>الاسم بالعربية</Label>
              <Input value={client.name_ar || ''} readOnly />
            </div>
            <div className="space-y-2">
              <Label>الاسم بالإنجليزية</Label>
              <Input value={client.name_en || ''} readOnly />
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="space-y-2">
              <Label>رقم الهاتف</Label>
              <Input value={client.mobile || ''} readOnly />
            </div>
            <div className="space-y-2">
              <Label>الشركة</Label>
              <Input value={client.company || client.companies?.name_ar || ''} readOnly />
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="space-y-2">
              <Label>نوع العميل</Label>
              <Input value={client.client_type || ''} readOnly />
            </div>
            <div className="space-y-2">
              <Label>الحالة</Label>
              <Input value={client.status || ''} readOnly />
            </div>
          </div>

          <div className="space-y-2">
            <Label>معلومات إضافية</Label>
            <Textarea value={client.additional_info || ''} readOnly className="min-h-[100px]" />
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}